module.exports = __webpack_public_path__ + "img/s-banner.2d1d82b8.svg";